import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: false,
  university: null,
  /** Snapshot of auth before impersonation; restored when stopping */
  previousAuth: null,
};

export const impersonationSlice = createSlice({
  name: "impersonation",
  initialState,
  reducers: {
    startImpersonation: (state, action) => {
      const { university, previousAuth } = action.payload;
      state.active = true;
      state.university = university;
      state.previousAuth = previousAuth;
    },
    stopImpersonation: (state) => {
      state.active = false;
      state.university = null;
      state.previousAuth = null;
    },
  },
});

export const { startImpersonation, stopImpersonation } = impersonationSlice.actions;
export default impersonationSlice.reducer;
